export default function Active() {
  return <div className="w-[10px] h-[10px] rounded-full bg-[#27AD27]"></div>;
}
